<template>
<!doctype html>
<html lang="pt-br">
  <head>
    <meta charset="utf-8" />
    <title>{{head.title}}</title>
    <meta name="theme-color" :content="head.color" />
    <meta name="msapplication-navbutton-color" :content="head.color" />
    <meta name="apple-mobile-web-app-status-bar-style" :content="head.color" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  </head>

  <body>
    <v-menu v-model="menu" :close-on-content-click="false" offset-x>
      <template v-slot:activator="{ on }">
        <header :style="{background: head.color, display: 'flex'}" v-on="on">
          <img
            @contextmenu="show"
            style="margin-left: 15px; padding: 10px; width: 65px;"
            :src="head.logo"
            alt
          />
          <h1 style="margin-top: 12px; margin-left: 5px; color: white">{{head.titulo}}</h1>
        </header>

        <v-menu
          v-model="showMenu"
          :position-x="x"
          :position-y="y+30"
          :close-on-content-click="false"
          offset-y
        >
          <v-layout>
            <v-flex xs12 sm6>
              <v-card height="400" width="400">
                <v-container grid-list-sm fluid>
                  <v-layout row wrap>
                    <v-flex v-for="n in 9" :key="n" xs4 d-flex>
                      <v-card flat tile class="d-flex">
                        <v-img
                          :src="`https://picsum.photos/500/300?image=${n * 5 + 10}`"
                          :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
                          aspect-ratio="1"
                          class="grey lighten-2"
                          @click="alteraLogo($event)"
                        >
                          <template v-slot:placeholder>
                            <v-layout fill-height align-center justify-center ma-0>
                              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-layout>
                          </template>
                        </v-img>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
        </v-menu>
      </template>

      <div>
        <chrome-picker style="width: 100%" v-model="colors" />
      </div>
    </v-menu>

    <img
      @contextmenu="showLogo"
      id="logo"
      :src="body.logo.src"
      :alt="body.logo.alt"
      style="padding: 15px;"
    />
    <!--<iframe width="396" height="305" src="https://www.youtube.com/embed/MOVedN-pMLo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
    <v-menu
      v-model="showMenu2"
      :position-x="x"
      :position-y="y+30"
      :close-on-content-click="false"
      offset-y
    >
      <v-layout>
        <v-flex xs12 sm6>
          <v-card height="400" width="400">
            <v-container grid-list-sm fluid>
              <v-layout row wrap>
                <v-flex v-for="n in 9" :key="n" xs4 d-flex>
                  <v-card flat tile class="d-flex">
                    <v-img
                      :src="`https://picsum.photos/500/300?image=${n * 5 + 10}`"
                      :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
                      aspect-ratio="1"
                      class="grey lighten-2"
                      @click="alteraImagem($event)"
                    >
                      <template v-slot:placeholder>
                        <v-layout fill-height align-center justify-center ma-0>
                          <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                        </v-layout>
                      </template>
                    </v-img>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-menu>
    <section id="texto" class="main">
      <p>{{body.texto}}</p>
    </section>

    <section id="actions" class="main">
      <v-menu v-if="body.botao.selecionaBtn" :close-on-content-click="false" offset-x>
        <template v-slot:activator="{ on }">
          <div
            class="btn"
            @click="abrirLink(!body.botao.selecionaMultiLinks ? body.botao.link : navigator.userAgent.match(/Android/i) ? body.botao.links.linkAndroid : navigator.userAgent.match(/iPhone|iPad|iPod/i) ? body.botao.links.linkIphone : body.botao.links.linkPc)"
            :style="{backgroundColor: body.botao.color}"
            v-on="on"
          >{{body.botao.label}}</div>
        </template>

        <div>
          <chrome-picker style="width: 100%" v-model="colors" />
        </div>
      </v-menu>
    </section>

    <section id="socialnetwork" class="main">
      <h1>Redes sociais</h1>
      <div>
        <button
          v-if="body.redes.whatsapp.selecionado"
          @click="abrirLink(`https://api.whatsapp.com/send?phone=55${body.redes.whatsapp.telefone}&text=salve&source=&data=`)"
        >
          <i
            class="fab fa-whatsapp-square"
            style="font-size: 1em;width:50px;height:50px;color:#00897b"
          ></i>
        </button>

        <button
          v-if="body.redes.dialer.selecionado"
          @click="abrirLink(`tel:+55-${body.redes.dialer.telefone}`)"
        >
          <i
            class="fas fa-phone-square-alt"
            style="font-size: 1em;width:50px;height:50px;color:#26C6DA"
          ></i>
        </button>

        <button
          v-if="body.redes.facebook.selecionado"
          @click="abrirLink(body.redes.facebook.pagina)"
        >
          <i
            class="fab fa-facebook-square"
            style="font-size: 1em;width:50px;height:50px;color:#3C5A99"
          ></i>
        </button>

        <button
          v-if="body.redes.email.selecionado"
          @click="abrirLink(`mailto:${body.redes.email.endereco}`)"
        >
          <i
            class="fas fa-envelope-square"
            style="font-size: 1em;width:50px;height:50px;color:#F44336"
          ></i>
        </button>

      </div>
    </section>

    <footer :style="{background: head.color, display: 'flex'}">
      <div class="center">
        <p v-html="footer.contato"></p>
      </div>
    </footer>
  </body>
</html>
</template>

<script>
import { Chrome } from "vue-color";
export default {
  props: ["head", "body", "footer"],
  components: {
    "chrome-picker": Chrome
  },
  data() {
    return {
      menu: false,
      x: 0,
      y: 0,
      showMenu: false,
      showMenu2: false,
      items: [
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me 2" }
      ],
      menuBtn1: false,
      menuBtn2: false,
      colors: "#00897B",
      colorBtn2: "#ff5252",
      layout: {
        _id: "",
        empresa_id: ""
      },
      /*head:{
                    title: "Agencia 56k",
                    color:"#00897B"
                },*/
      btn1: {
        color: "#00897B",
        label: "Abrir site",
        link:
          "https://www.google.com/search?q=logo+png+vuejs&source=lnms&tbm=isch&sa=X&ved=0ahUKEwiL7qi5svXhAhUk1VkKHbTdAQAQ_AUIDigB&biw=1440&bih=828#imgrc=Zp6VNYlGNgVN6M:"
      },
      btn2: {
        color: "#ff5252",
        label: "Cancelar",
        link: "https://dash-root.56k.com.br/#/"
      },
      socialnetwork: [
        {
          src:
            "https://logodownload.org/wp-content/uploads/2015/04/whatsapp-logo-1.png",
          alt: "whatsapp",
          link:
            "https://api.whatsapp.com/send?phone=5516997659374&text=salve&source=&data="
        },
        {
          src: "https://www.freeiconspng.com/uploads/phone-call-icon-16.png",
          alt: "dialer",
          link: "tel:+1-303-499-7111"
        },
        {
          src: "https://brasilparkshopping.com.br/img/facebook2.png",
          alt: "facebook",
          link: ""
        },
        {
          src:
            "https://s3.amazonaws.com/cayenne-plugin-test/wp-content/uploads/2018/08/297671.png",
          alt: "email",
          link: ""
        }
      ]
    };
  },
  methods: {
    alteraLogo(evento) {
      this.head.logo = "https://picsum.photos/500/300?image=25";
      this.showMenu = false;
    },
    alteraImagem(evento) {
      this.body.logo.src = "https://picsum.photos/500/300?image=35";
      this.showMenu2 = false;
    },
    abrirLink(link) {
      window.open(link);
    },
    show(e) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    showLogo(e) {
      e.preventDefault();
      this.showMenu2 = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu2 = true;
      });
    }
  },

  watch: {
    colors() {
      if (this.menu) {
        this.head.color = this.colors.hex8;
        this.$emit("update:head.color", !this.head.color);
      }
      if (this.menuBtn1) {
        this.botao.color = this.colors.hex8;
        this.$emit("update:botao", this.botao);
      }
    },
    colorBtn2() {
      this.botoes.btn2.color = this.colorBtn2.hex8;
      this.$emit("update:botoes.btn2", this.botoes.btn2);
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: verdana;
}

.center p {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  color: white;
  font-size: 1.2em;
}

h1 {
  font-weight: normal;
}

.main {
  margin: auto;
  max-width: 90%;
}

.btn {
  display: flex;
  justify-content: center;

  align-items: center;
  border-radius: 3px;
  color: white;
  padding: 3% 7%;
  cursor: pointer;
}

header {
  height: 65px;
  box-shadow: 3px 3px 3px #ccc;
}

#logo {
  display: block;
  margin: auto;
  margin-top: 20px;
  max-width: 90%;
}

footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 60px; /* Height of the footer */
}

#texto {
  padding: 5%;
}

#texto p {
  text-align: justify;
  text-justify: inter-word;
  font-size: 1.2em;
  color: gray;
  line-height: 25px;
  margin-bottom: 20px;
}

#actions {
  padding: 5%;
  display: flex;
  justify-content: center;
}

#socialnetwork h1 {
  text-align: center;
  font-size: 0.9em;
  margin-top: 50px;
  margin-bottom: 10px;

  color: #3d3d3d;
}

#socialnetwork img {
  width: 15%;
  margin-right: 6%;
  margin-right: 6%;
  cursor: pointer;
}

#socialnetwork div {
  width: 90%;
  display: flex;
  margin: auto;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}
</style>






// WEBPACK FOOTER //
// src/components/user/push/layout/layout.vue